import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faLaptop, faDollarSign, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import Price from 'Components/Utility/Price/Price';
import Saving from 'Components/Utility/Price/Saving';

function BundleSoftwarePoints({
  price,
  fullPrice,
  discountPercentOverride,
  maxPrice,
  mixedBundle,
  totalGameCount,
  validDrm,
  tiered,
  bundleSlug,
}) {
  return (
    <div className="BundlePoints BundlePoints--software">
      <div className="BundlePoints__points container">
        <div className="BundlePoints__point">
          <div className="BundlePoints__dollarIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faDollarSign} />
          </div>
          <div className="BundlePoints__pointText">
            {(mixedBundle || (!mixedBundle && validDrm[0] !== 'steam')) &&
              <FormattedMessage
                id="software-bar.worth_of_products"
                defaultMessage="Get {price} worth of products"
                values={{
                  price: <Price price={maxPrice} />,
                }}
              />
            }
            {!mixedBundle && validDrm[0] === 'steam' &&
              <FormattedMessage
                id="software-bar.worth_of_steam"
                defaultMessage="Get {price} worth of Steam keys"
                values={{
                  price: <Price price={maxPrice} />,
                }}
              />
            }
          </div>
        </div>

        <div className="BundlePoints__point">
          <div className="BundlePoints__gameIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faTag} />
          </div>
          <div className="BundlePoints__pointText">
            <FormattedMessage
              id="software-bar.software_saving"
              defaultMessage="Save {saving}"
              values={{
                saving: <Saving
                  price={price}
                  type="bundle"
                  fullPrice={fullPrice}
                  discountPercentOverride={discountPercentOverride}
                  showMinus={false}
                />,
              }}
            />
          </div>
        </div>

        {!tiered && totalGameCount > 0 && validDrm[0] !== 'drm_free' && bundleSlug !== 'blender-3-d-modeling-course-elearning-bundle' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faLaptop} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="software-bar.keys-total"
                defaultMessage="{totalGameCount} Individual keys delivered"
                values={{ totalGameCount }}
              />
            </div>
          </div>
        }

        {!isEmpty(validDrm) && validDrm[0] !== '' && validDrm[0] !== 'drm_free' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="software-bar.point.redeem"
                defaultMessage="Redeem keys on {drm}"
                values={{
                  drm: <span>{validDrm[0]}</span>,
                }}
              />
            </div>
          </div>
        }

        {!isEmpty(validDrm) && validDrm[0] === 'drm_free' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="software-bar.point.redeem.drm-free"
                defaultMessage="DRM Free downloads"
              />
            </div>
          </div>
        }

        {isEmpty(validDrm) && bundleSlug !== 'boost-your-gaming-and-more-pc-bundle' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="software-bar.point.redeem.keys"
                defaultMessage="Redeem via publisher website"
              />
            </div>
          </div>
        }

        {isEmpty(validDrm) && bundleSlug === 'boost-your-gaming-and-more-pc-bundle' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="software-bar.point.redeem.keys.hard-code"
                defaultMessage="Key Redemption"
              />
            </div>
          </div>
        }
      </div>
    </div >
  );
}

BundleSoftwarePoints.propTypes = {
  price: PropTypes.shape({}),
  fullPrice: PropTypes.shape({}),
  maxPrice: PropTypes.shape({}),
  discountPercentOverride: PropTypes.number,
  mixedBundle: PropTypes.bool,
  totalGameCount: PropTypes.number,
  validDrm: PropTypes.arrayOf(PropTypes.string),
  tiered: PropTypes.bool,
  bundleSlug: PropTypes.string,
};

BundleSoftwarePoints.defaultProps = {
  price: {},
  fullPrice: {},
  maxPrice: {},
  discountPercentOverride: 0,
  mixedBundle: false,
  totalGameCount: 0,
  validDrm: [],
  tiered: false,
  bundleSlug: '',
};


const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(BundleSoftwarePoints);
